<template>
  <div>
    <div class="pricing-table">
      <div
        class="pricing-plan"
        v-for="(item, itemIndex) in data"
        :key="itemIndex"
        :class="{ 'is-active': item.selected }"
      >
        <dynamic-content class="plan-header" :content="item.title" />
        <div
          class="plan-price"
          v-for="(price, priceIndex) in item.prices"
          :key="priceIndex"
        >
          <span
            class="plan-price-amount"
            :class="{ [getColor(itemIndex + priceIndex * 2)]: true }"
            >{{ price.price }}</span
          >
          {{ price.currency }}
          <dynamic-content
            class="price-disclaimer"
            v-if="price.disclaimer"
            :content="price.disclaimer"
          />
        </div>
        <div class="plan-price description" v-if="item.description">
          <dynamic-content :content="item.description" />
        </div>
        <div class="plan-items">
          <div
            class="plan-item"
            v-for="(feature, featureIndex) in padFeatures(item.features)"
            :key="featureIndex"
          >
            {{ feature }}
          </div>
        </div>
        <div class="plan-footer">
          <slot name="footer" :item="item" />
        </div>
      </div>
    </div>
    <div class="disclaimer" v-if="disclaimer">
      <div class="columns">
        <div class="column is-8 is-offset-2">
          <dynamic-content class="has-text-centered" :content="disclaimer" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { DynamicContent } from "%helpers";

const COLOR = [
  "has-text-info",
  "has-text-primary",
  "has-text-success",
  "has-text-warning",
  "has-text-danger"
];

export default {
  name: "pricing-table",

  components: {
    DynamicContent
  },

  props: {
    data: Array,
    disclaimer: String
  },

  methods: {
    padFeatures(features) {
      return [
        ...features,
        ...Array.from("\u2014".repeat(this.maxFeaturesNumber - features.length))
      ];
    },

    getColor(index) {
      return COLOR[index % COLOR.length];
    }
  },

  computed: {
    maxFeaturesNumber() {
      return Math.max(...this.data.map(item => item.features.length));
    }
  }
};
</script>

<style lang="scss" scoped>
.price-disclaimer {
  font-style: italic;
}

.description {
  &::before {
    content: "";
    display: block;
    width: 1rem;
    border-top: solid 1px $grey-lighter;
    margin: 0 auto 0.75rem;
  }
}

.disclaimer {
  margin-top: 7rem;
  font-family: $family-sans-serif;
  color: $grey;
  padding: 1rem;
}
</style>
